import { getFirstCollectionRelatedEventCode } from 'helpers/wallet/events'

import { useCollectionEvents } from 'hooks/useCollection'
import { useCurrentLanguage } from 'hooks/useCurrentLanguage'

import EventDataFetcher from './EventDataFetcher'

interface Props {
  collectionId: number
}

const CollectionRelatedFirstEventDataFetcher: React.FC<Props> = (props: Props) => {
  const { collectionId } = props

  const language = useCurrentLanguage()

  const relatedEvents = useCollectionEvents({ id: String(collectionId), language })

  if (!relatedEvents) {
    return null
  }

  const eventCode = getFirstCollectionRelatedEventCode(relatedEvents.data)

  return <EventDataFetcher eventIds={[eventCode]} />
}

export default CollectionRelatedFirstEventDataFetcher
